import { env } from "@/configs/env";

/**
 * Media proksisining yo'li.
 *
 * Backend saqlagich (MinIO/SeaweedFS) manzilini HECH QACHON bermaydi: har bir
 * rasm, video va hujjat `/api/v1/media/<token>` ko'rinishidagi NISBIY havola
 * bo'lib keladi. Token ~15 daqiqa yashaydi va ruxsatnomaning o'zi.
 */
export const MEDIA_PATH_PREFIX = "/api/v1/media/";

/**
 * API ning ORIGIN i (`http://localhost:7777`), `/api/v1` prefiksisiz.
 *
 * Nisbiy media havolasi panelning o'z manziliga (`:3040`) ketardi — Vite uni
 * `index.html` bilan javob qaytaradi va har bir rasm buzilgan kvadrat bo'lib
 * chiqardi. Prodda API nisbiy (`/api/v1`) bo'lsa origin bo'sh qaytadi va
 * havola o'zgarmaydi — nginx uni o'sha domendan o'zi uzatadi.
 */
export const apiOrigin = (baseUrl: string = env.API_BASE_URL): string => {
  try {
    return new URL(baseUrl).origin;
  } catch {
    return "";
  }
};

/** Havola media proksisiga tegishlimi (nisbiy ham, to'liq ham). */
export const isMediaProxyUrl = (url: string | null | undefined): boolean =>
  typeof url === "string" && url.includes(MEDIA_PATH_PREFIX);

/**
 * Media havolasini brauzer ocha oladigan ko'rinishga keltiradi.
 *
 * Nisbiy `/api/v1/media/...` API originiga ulanadi; tashqi manzil (YouTube,
 * Google avatari) va `blob:`/`data:` havolalar O'ZGARISHSIZ qaytadi.
 */
export const resolveMediaUrl = (
  url: string | null | undefined,
  baseUrl: string = env.API_BASE_URL,
): string | undefined => {
  if (!url) return undefined;
  if (!url.startsWith("/")) return url;

  const origin = apiOrigin(baseUrl);
  return origin ? `${origin}${url}` : url;
};

/** base64url → matn; buzilgan kirishda `null`. */
const decodeBase64Url = (value: string): string | null => {
  try {
    const base64 = value.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    const binary = atob(padded);
    const bytes = Uint8Array.from(binary, char => char.charCodeAt(0));
    return new TextDecoder().decode(bytes);
  } catch {
    return null;
  }
};

/**
 * Proksi havolasi ortidagi obyektning NOMI (`2026/09/abc.pdf` → `abc.pdf`).
 *
 * Fayl ko'ruvchi turni kengaytmadan aniqlaydi, proksi havolasida esa
 * kengaytma yo'q — `/api/v1/media/eyJr...`. Shu sababli diplom va
 * ilovalar "qo'llab-quvvatlanmaydi" deb chiqardi. Tokenning birinchi
 * qismi imzolanmagan JSON (`{"k": "<obyekt kaliti>", ...}`): uni o'qish
 * xavfsiz, chunki bu yerda ruxsat emas, faqat ko'rinish hal qilinadi.
 */
export const mediaObjectName = (url: string | null | undefined): string | null => {
  if (!url || !isMediaProxyUrl(url)) return null;

  const token = url.split(MEDIA_PATH_PREFIX)[1]?.split(/[?#]/)[0] ?? "";
  const payload = token.split(".")[0];
  if (!payload) return null;

  const json = decodeBase64Url(payload);
  if (!json) return null;

  try {
    const parsed: unknown = JSON.parse(json);
    const key = (parsed as { k?: unknown } | null)?.k;
    if (typeof key !== "string" || key.length === 0) return null;
    return key.split("/").pop() || null;
  } catch {
    return null;
  }
};
